/**
 * useBusSync — subscribes to BroadcastChannel messages from other tabs
 * and updates the local Zustand store. Mount once at the app root.
 */
import { useEffect } from 'react'
import { terminalBus, type BusMessage } from '../lib/terminalBus'
import { useTerminalStore } from '../store/terminalStore'

export function useBusSync() {
  useEffect(() => {
    return terminalBus.subscribe((msg: BusMessage) => {
      switch (msg.type) {
        case 'SYMBOL_CHANGE':
          // Use internal set to avoid re-publishing back to bus
          useTerminalStore.setState({ activeSymbol: msg.symbol })
          break
        case 'PERIOD_CHANGE':
          useTerminalStore.setState({ chartPeriod: msg.period as never })
          break
        case 'INTERVAL_CHANGE':
          useTerminalStore.setState({ chartInterval: msg.interval as never })
          break
        // CROSSHAIR_MOVE is handled per-chart via useCrosshairSync
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
